import { queryOptions } from "@tanstack/react-query";

import { getConnectedAccountsView } from "./server-fns";

export function connectedAccountsQueryKey() {
  return ["connectedAccounts"] as const;
}

export function connectedAccountsQueryOptions() {
  return queryOptions({
    queryKey: connectedAccountsQueryKey(),
    queryFn: () => getConnectedAccountsView(),
    staleTime: 15_000,
  });
}
